import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import style from "../style/Gsc.module.scss";

const cn = className.bind(style);

/**
 * Huy hiệu % thay đổi so với kỳ liền trước (dùng cho thẻ tổng quan + bảng top).
 * value: số (%) | null ("mới" — kỳ trước = 0) | undefined/0 (không đổi).
 * `invert` cho chỉ số mà nhỏ hơn là tốt (đã đảo dấu ở BE với vị trí nên thường không cần).
 */
export function TrendBadge({value}) {

	if (value === null) {
		return <span className={cn('trend', 'new')}>Mới</span>;
	}

	if (value === undefined || value === 0) {
		return <span className={cn('trend', 'flat')}>—</span>;
	}

	const up = value > 0;

	return (
		<span className={cn('trend', up ? 'up' : 'down')}>
			<FontAwesomeIcon icon={`fa-solid fa-arrow-${up ? 'up' : 'down'}`} /> {Math.abs(value)}%
		</span>
	);
}

/** Điểm xếp hạng "tăng" — "mới" (null) coi như tăng mạnh nhất. */
function upScore(row) {
	return row.delta_pct === null ? Number.MAX_SAFE_INTEGER : (row.delta_pct || 0);
}

/**
 * Lọc/sắp xếp danh sách theo 3 nhóm giống GSC:
 *  - top:  giữ nguyên (đang theo clicks giảm dần)
 *  - up:   đang tăng (delta > 0 hoặc "mới"), sắp theo mức tăng
 *  - down: đang giảm (delta < 0), sắp theo mức giảm
 */
export function bucketRows(rows = [], mode = 'top') {
	if (mode === 'up') {
		return rows
			.filter((r) => r.delta_pct === null || (typeof r.delta_pct === 'number' && r.delta_pct > 0))
			.sort((a, b) => upScore(b) - upScore(a));
	}

	if (mode === 'down') {
		return rows
			.filter((r) => typeof r.delta_pct === 'number' && r.delta_pct < 0)
			.sort((a, b) => a.delta_pct - b.delta_pct);
	}

	return rows;
}

export const BUCKETS = [
	{label: 'Đầu bảng', value: 'top'},
	{label: 'Đang tăng', value: 'up'},
	{label: 'Đang giảm', value: 'down'},
];
